import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { CEREMONY_SITE_ID, CEREMONY_RESERVATION_SITE_ID, first, second } from '../../constants';
import BookingInsure from '../../services';
import _ from 'lodash';

const Month = ({onChange, setIsLoading}) => {
    const repo = new BookingInsure();
    const dayOfWeek = [ "日", "月", "火", "水", "木", "金", "土" ];
    const [currentMonth, setCurrentMonth] = useState(moment().startOf('month'));
    const [items, setItems] = useState([]);
    const [checkSeatInMonth, setCheckSeatInMonth] = useState([]);
    const check = ['×', '△', '〇', ''];
    const fakeData = 0;
    const loadData = async () => {
        try {
            setIsLoading(true);
            const startMonth = moment(currentMonth).startOf('month');
            const lastMonth = moment(currentMonth).endOf('month');
            const halls = fakeData ? first : await repo.get(CEREMONY_SITE_ID, { unactive: false });
            const weekData = fakeData ? second : await repo.get(CEREMONY_RESERVATION_SITE_ID, {
                startDate: startMonth.format('YYYY-MM-DD'),
                endDate: lastMonth.format('YYYY-MM-DD'),
            });
            const activeHalls = _.map(_.filter(halls, { "unactive": false }), 'id');
            const listCheckMonth = [];
            const time = [];
            for (let index = 9; index < 21; index++) {
                time.push({
                    first: `${index}:00`,
                    second: `${index}:30`,
                });
            }
            for (let index = currentMonth.date(); index <= lastMonth.date(); index++) {
                const timeOfHall = weekData.filter((e) => activeHalls.includes(Number(e.idCeremy)) && moment(`${startMonth.format('YYYY-MM')}-${index}`).diff(moment(e.bookDate), 'days') === 0);
                if (timeOfHall.length > 0) {
                    const totalTimeOfHall = _.chain(timeOfHall).groupBy('idCeremy').value();
                    listCheckMonth[index] = [];
                    for (let i = 0; i < time.length; i++) {
                        const element = time[i];
                        const firstTime = new Date(`${startMonth.format('YYYY-MM')}-${index} ${element.first}:00`);
                        const secondTime = element.second ? new Date(`${startMonth.format('YYYY-MM')}-${index} ${element.second}:00`) : null;
                        let checkFirst = 0;
                        let checkSecond = 0;
                        Object.keys(totalTimeOfHall).forEach((key) => {
                            const element = totalTimeOfHall[key];
                            if (_.find(element, (e) => (new Date(e.startDate).getTime() <= firstTime.getTime() && firstTime.getTime() <= new Date(e.endDate).getTime()))) {
                                checkFirst += 1;
                            }
                            if (secondTime && _.find(element, (e) => (new Date(e.startDate).getTime() <= secondTime.getTime() && secondTime.getTime() <= new Date(e.endDate).getTime()))) {
                                checkSecond += 1;
                            }
                        });
                        listCheckMonth[index] = {
                            ...listCheckMonth[index],
                            [element.first]: checkFirst === activeHalls.length ? 0 : (checkFirst === 0 ? 2 : 1), 
                            ...secondTime ? {[element.second]: checkSecond === activeHalls.length ? 0 : (checkSecond === 0 ? 2 : 1)} : {},
                        };
                    }
                } else {
                    listCheckMonth[index] = {};
                    for (let i = 0; i < time.length; i++) {
                        const element = time[i];
                        listCheckMonth[index] = {...listCheckMonth[index], [element.first]: 2, ...element.second ? {[element.second]: 2} : {}};
                    }
                }
            }
            setCheckSeatInMonth(listCheckMonth.map((i, index) => {
                if (_.isEmpty(i)) {
                    return i;
                }
                const length = Object.values(i).length;
                const countEmpty = _.filter(Object.values(i), (o) => o == 2).length; // o
                // const countRemain = _.filter(Object.values(i), (o) => o == 1).length; // tam giac
                const countFull = _.filter(Object.values(i), (o) => o == 0).length; // x
                if (countFull === length) return 0; // x
                if (countEmpty >= 7) return 2; // o
                return 1;
            }));
            setIsLoading(false);
        } catch(e) {
            setIsLoading(false);
            console.log(e);
        }
    }
    useEffect(() => {
        const day = currentMonth.day();
        const prevMonth = moment(currentMonth).subtract(1, 'months').endOf("month");
        const days = [[]];
        let nextDays = 0;
        for (let index = 0; index < 7; index++) {
            if (index < day) {
                days[0].unshift({disable: true, value: prevMonth.date() - index});
            } else {
                days[0].push({disable: false, value: nextDays + 1});
                nextDays++;
            }
        }
        const lastMonth = moment(currentMonth).endOf('month');
        let position = 0;
        for (let index = nextDays + 1; index <= lastMonth.date(); index++) {
            if (days[position].length < 7) {
                days[position].push({disable: false, value: index});
            } else {
                days.push([{disable: false, value: index}]);
                position++;
            }
        }
        const remainLength = 7 - days[days.length - 1].length;
        if (days[days.length - 1].length < 7) {
            for (let index = 1; index <= remainLength; index++) {
                days[days.length - 1].push({disable: true, value: index});
            }
        }
        setItems(days);
        loadData().then();
    }, [currentMonth]);
    return (
        <>
            <div className="position-relative d-flex px-3 justify-content-between align-items-center w_300">
                <div className="bd-highlight pointer" onClick={(e) => {
                    e.preventDefault();
                    const value = moment(currentMonth).subtract(1, "months");
                    setCurrentMonth(value);
                }}>
                    <i className="ri-arrow-left-s-line tx-30 text-primary"></i>
                </div>
                <div className="bd-highlight tx-30">
                    {currentMonth.format("yyyy年 MM月")}
                </div>
                <div className="bd-highlight pointer">
                    <i className="ri-arrow-right-s-line tx-30 text-primary" onClick={(e) => {
                        e.preventDefault();
                        const value = moment(currentMonth).add(1, "months");
                        setCurrentMonth(value);
                    }}></i>
                </div>
            </div>
            
            <div className="position-relative">
                <div className="d-flex flex-column align-items-center resize month">
                    <div className="d-flex flex-row text-center">
                        <div className="w_100 pxy-3"></div>
                        {
                            dayOfWeek.map((item, index) => (
                                <div key={item+index} className={`w_200 tx-28 pxy-3 text-center ${index === 0 && 'text-danger'} ${index === dayOfWeek.length - 1 && 'text-primary'}`}>{item}</div>
                            ))
                        }
                    </div>
                    <div className="border-right border-bottom" style={{width: "max-content"}}>
                        {
                            items.map((item, index) => (
                                <div key={item+index} className="d-flex flex-row border-top">
                                    <div className="border-left d-flex justify-content-center align-items-center w_100 h_100 tx-24 pxy-3" onClick={(e) => {
                                        e.preventDefault();
                                        onChange(
                                            moment(`${currentMonth.year()}-${currentMonth.month() + 1}-${item[6].value}`), 
                                            index + 1
                                        );
                                    }}>{`${index + 1}週`}</div>
                                    {
                                        item.map(i => (
                                            <div key={i.value} className={`d-flex flex-column justify-content-center align-items-center border-left w_200 h_100 position-relative ${i.disable ? 'text-secondary' : 'pointer'}`} onClick={(e) => {
                                                if (i.disable || checkSeatInMonth[i.value] === 0) return;
                                                onChange(
                                                    moment(`${currentMonth.year()}-${currentMonth.month() + 1}-${item[item.length - 1].value}`), 
                                                    index + 1
                                                );
                                            }}>
                                                <div className="position-absolute position text-start tx-18 pl">
                                                    {i.value}
                                                </div>
                                                {
                                                    !i.disable && 
                                                    <div className="p-1 bd-highlight text-center tx-36">
                                                        {check[checkSeatInMonth[i.value]]}
                                                    </div>
                                                }
                                            </div>
                                        ))
                                    }
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default Month;